module.exports = "/images/warning@3x.png?a358078486875eac6cd393e4adcac006";